import { Component, OnInit, Input, Output, EventEmitter } from '@angular/core';

import { OrderDetail } from '../../../core';
import { environment } from '../../../../environments/environment';
import { inStorePickingDetail } from '../data-table/data-table-config';

@Component({
  standalone: false,
  selector: 'app-product-card',
  templateUrl: './product-card.component.html',
  styleUrls: ['./product-card.component.scss']
})
export class ProductCardComponent implements OnInit {
  @Input() data: OrderDetail;
  @Output() select = new EventEmitter<any>();
  @Input() entityCode: string;

  constructor() { }

  ngOnInit() { }

  onChange(checked: boolean) {
    this.select.emit(checked);
  }

  valueDisabled(): boolean {
    return inStorePickingDetail.hasDisabledCheckBoxItem(this.data);
  }

  valueColor(status) {
    return {
      'in-process': status === 'EN PROCESO' ? true : false,
      'in-store': status !== 'EN PROCESO' && status !== 'ENTREGADO TOTALMENTE' ? true : false,
      'deliver': status === 'ENTREGADO TOTALMENTE' ? true : false
    };
  }

  isUserEntity(): boolean {
    if (localStorage.getItem(environment.sessionAuth)) {
      const session = JSON.parse(localStorage.getItem(environment.sessionAuth));
      const existEntity = session.user.entities.find(item => item.entityCode.includes(this.entityCode));
      return session && existEntity;
    } else {
      return false;
    }
  }
}
